module.exports = __webpack_public_path__ + "img/connections-download-image.095e24ed.png";